import type { FaceKey } from '@repo/api-contracts';

export const FACE_LABELS: Readonly<Record<FaceKey, string>> = {
  front: '앞면 Front',
  back: '뒷면 Back',
  left: '왼쪽 Left',
  right: '오른쪽 Right',
};
